import { Button } from "@/components/ui/button";
import { ArrowRight, Clock, MapPin, Phone } from "lucide-react";
import heroImage from "@/assets/hero-pharmacy.webp";
import { useBookingLink } from "@/hooks/useBookingLink";

export const Hero = () => {
  const bookingUrl = useBookingLink("page", "hero", "https://healthclinicshull.setmore.com");
  const scrollToServices = () => {
    document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Wilberforce Pharmacy storefront in Hull"
          width={1600}
          height={1067}
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/85 to-background/70" />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl space-y-8 animate-fade-in">
          <h1 className="text-5xl md:text-7xl font-bold text-foreground leading-tight">
            Your Trusted
            <span className="block bg-gradient-to-r from-primary via-primary-glow to-secondary bg-clip-text text-transparent">
              Healthcare Partner
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">
            Expert NHS and private healthcare services in Hull. From travel vaccinations to wellness treatments, we're here for your health journey.
          </p>

          <div className="flex flex-wrap gap-4">
            <Button 
              variant="hero" 
              size="xl"
              asChild
              className="gap-2 shadow-[var(--shadow-glow)]"
            >
              <a href={bookingUrl} target="_blank" rel="noopener noreferrer">
                Book Appointment
                <ArrowRight className="w-5 h-5" />
              </a>
            </Button>
            <Button 
              variant="outline" 
              size="xl"
              className="gap-2 bg-background/50 backdrop-blur-sm"
              onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            >
              <Phone className="w-5 h-5" />
              Contact Us
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-8">
            <div className="flex items-center gap-3 bg-card/50 backdrop-blur-sm rounded-lg p-4 border border-border">
              <MapPin className="w-6 h-6 text-primary" />
              <div>
                <p className="font-semibold text-foreground">Location</p>
                <p className="text-sm text-muted-foreground">Hull, East Yorkshire</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-card/50 backdrop-blur-sm rounded-lg p-4 border border-border">
              <Clock className="w-6 h-6 text-primary" />
              <div>
                <p className="font-semibold text-foreground">Open Daily</p>
                <p className="text-sm text-muted-foreground">Mon-Sat 9AM-6PM</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-card/50 backdrop-blur-sm rounded-lg p-4 border border-border">
              <Phone className="w-6 h-6 text-primary" />
              <div>
                <p className="font-semibold text-foreground">Call Us</p>
                <p className="text-sm text-muted-foreground">Book by Phone</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};